import styled from 'styled-components';
import { LayoutProps, layout, BorderProps, border, ColorProps, color, PositionProps, position, BackgroundColorProps } from 'styled-system';
import { VStack, Text } from '@bpba/ui-components';

const VIDEO_WIDTHS = [336, 432, 479];
const VIDEO_HEIGHTS = [189, 243, 269];
const VIDEO_BORDER_RADIUS = 8; // px
const HIDE_VIDEO_BORDER_WIDTH = 2; //px

type VideoProps = {
  videoUrl?: string | undefined;  
  tabIndex?: number;
} & BackgroundColorProps;

export function Video({ videoUrl, backgroundColor, tabIndex }: VideoProps) {
  if (!videoUrl || videoUrl.trim().length === 0) return <></>;
  return (
    <VStack>
      <Text marginBottom={24} marginTop={22} tabIndex={tabIndex}>
        Te recomendamos mirar este tutorial:
      </Text>
      <Container width={VIDEO_WIDTHS} height={VIDEO_HEIGHTS} borderRadius={VIDEO_BORDER_RADIUS + HIDE_VIDEO_BORDER_WIDTH} overflow="hidden">
        <HideBorders
          width={VIDEO_WIDTHS}
          height={VIDEO_HEIGHTS}
          borderColor={backgroundColor}
          borderRadius={VIDEO_BORDER_RADIUS}
          borderWidth={HIDE_VIDEO_BORDER_WIDTH}
        />
        <iframe
          tabIndex={tabIndex}
          width="100%"
          height="100%"
          src={videoUrl}
          title="Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </Container>
    </VStack>
  );
}

const Container = styled.div<LayoutProps & BorderProps>(layout, border);

/**Componente utilizado para tapar las esquinas grises que
 * aparecen en los videos de Youtube cuando se agregan
 * esquinas redondeadas (borderRadius).
 */
type HideBordersProps = LayoutProps & BorderProps & ColorProps & PositionProps;
const HideBorders = styled(Container)<HideBordersProps>(color, position, {
  position: 'absolute',
  borderStyle: 'solid',
  backgroundColor: 'transparent',
  pointerEvents: 'none',
});
